import { HashRouter } from "react-router-dom";
import "./App.css";
import AppRouter from "./routers/AppRouter";
import { AuthProvider } from "./context/AuthContext";
import { AxiosInterceptor } from "./services/axios-client";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
      <HashRouter>
        <AuthProvider>
          <AxiosInterceptor>
            <AppRouter />
          </AxiosInterceptor>
        </AuthProvider>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          limit={3}
          style={{
            fontSize: '15px',
            fontWeight: '500'
          }}
        />
      </HashRouter>
    </>
  );
}

export default App;